import {types} from '../../types';

const setGetListPaymentSystemAction = (payload) => {
    return {
        type: types.replenishment.SET_LIST,
        payload,
      }
}

export {
  setGetListPaymentSystemAction as SetGetListPaymentSystemAction,
}